import { Component, Input } from '@angular/core';
import { FILTER_TYPE } from 'src/app/enums/filters.constants';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {

  @Input() columns: any[] = [];
  @Input() type: string = "";
  @Input() rows: any[] = [];

  constructor() { }

  getRowStyle() {
    let style: any = {};
    style.display = 'grid';
    style.gridTemplateColumns = `.75fr repeat(${this.columns.length - 1}, 1fr)`;
    return style;
  }

  getCellValue(value: any) {
    const placeholder = "---";
    switch (typeof value) {
      case "string": {
        return value || placeholder
      }
      case "number": {
        return value;
      }
      default: return value;
    }
  }

  parseNumberValue(value: number) {
    if (!Number.isNaN(value)) {
      return value.toLocaleString(navigator.language);
    } else {
      return "";
    }
  }

  canShowTag(val: any) {
    if (this.type === FILTER_TYPE.ANALYTICS_PRODUCTS) {
      return val.bfs > 0;
    }
    return true;
  }

  getMediaUrl(el: any) {
    return el.mediaUrl || el.media;
  }

  getImg(elem: any) {
    return 'url(' + this.getMediaUrl(elem) + ')';
  };
}

